import React, { Fragment } from 'react';
import { GOOGLE_MAPS_LINK } from '@/constants';
import { styWrapper } from './styles';
import Peta from '@assets/images/peta.jpeg';

function LocationSection() {
  return (
    <Fragment>
      <div id="fh5co-couple-story" className="fh5co-section-gray" css={styWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center fh5co-heading animate-box">
              <h2 className="main-font">Lokasi Acara</h2>
              <p className="sub-title">
                <a
                  href={GOOGLE_MAPS_LINK}
                  title="Click untuk melihat peta di Google Maps"
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: '#828282' }}
                >
                </a>{' '}
                <br />
                Dusun Kunci RT.09 RW.03 Desa Wringinanom Kecamatan Poncokusumo Kabupaten Malang
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-10 col-md-offset-1">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3950.680946649517!2d112.79477307500753!3d-8.031793991994961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwMDEnNTQuNSJTIDExMsKwNDcnNTAuNSJF!5e0!3m2!1sid!2sid!4v1762949140786!5m2!1sid!2sid"
                width="100%"
                height="450"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen
                aria-hidden="false"
                tabIndex="0"
                title="Google Maps - Yayuk & Bayu Wedding Party"
              ></iframe>
            </div>
            
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default React.memo(LocationSection);
